import { Button } from "@blueprintjs/core"
import Shortcode from "src/libs/useful/shortcode"
import { __ } from "src/libs/utilities"
import { components } from "src/modules/pe-landing-module/data/utils/components"


const SinglePrimitiveLayer = ({primitive}: any) : JSX.Element => {
    const name = !!components()[ primitive.type ] ? components()[ primitive.type ].title : primitive.type
    const icon = !!components()[ primitive.type ] ? components()[ primitive.type ].icon  : "/assets/img/landing/" + primitive.type + ".svg"
    return <div className="panel-list-button pl-4 pr-1"> 
        <img src={ icon } alt="" height={12} className="panel-icon pr-1 ml-3" />
        <Shortcode className="small text-light text-overflow flex-grow-100 px-1" content={ __( name ) + " <span class='opacity_5 small'>#" + primitive.id + "</span>" } />
        {/* <Button variant="minimal" >
            <i className="fas fa-lock-open"></i>
        </Button> */}
        <Button variant="minimal" >
            <i className="far fa-eye"></i>
        </Button>
        <Button variant="minimal" >
            <i className={ "fas fa-trash" }></i> 
        </Button>
    </div>
}

export default SinglePrimitiveLayer